var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 49,
    viewBox: "0 0 51 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9027 47.0001H19.9532H41.999C46.2386 47.0001 47.8638 46.2223 48.1464 45.8334C48.9943 45.0556 48.9095 42.4111 46.8745 37.2777C44.8395 32.1442 36.4169 29.046 32.46 28.1385C25.4647 27.0367 10.1598 26.9719 4.9027 35.5276C-0.354373 44.0834 2.71226 46.7408 4.9027 47.0001Z",
    stroke: "white",
    strokeWidth: 3.33237
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1377 29.3038C19.3598 40.8151 20.4479 43.4337 20.5893 43.3041L23.7689 32.8038C22.5677 31.3131 20.4197 28.3315 21.4372 28.3315C22.709 28.3315 23.9809 27.3593 28.8564 28.3315C29.0684 28.7852 28.9836 30.3148 26.9486 32.8038",
    stroke: "white",
    strokeWidth: 3.33237
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8906 29.0383C30.6685 40.5497 29.5804 43.1683 29.4391 43.0387L26.9489 32.7869C28.1501 31.2961 29.6623 28.1376 28.6448 28.1376C27.3729 28.1376 26.313 26.9887 21.4375 27.9609C21.2255 28.4146 21.5223 30.0493 23.5573 32.5383",
    stroke: "white",
    strokeWidth: 3.33237
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.937 12.0099C35.937 17.4517 31.2678 22.007 25.326 22.007C19.3841 22.007 14.715 17.4517 14.715 12.0099C14.715 6.56821 19.3841 2.01286 25.326 2.01286C31.2678 2.01286 35.937 6.56821 35.937 12.0099Z",
    stroke: "white",
    strokeWidth: 3.33237
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorp);
export default __webpack_public_path__ + "static/media/corp.c76662e05a8027ed992f4d67428b65a0.svg";
export { ForwardRef as ReactComponent };